import script from "./color.vue?vue&type=script&setup=true&lang=js"
export * from "./color.vue?vue&type=script&setup=true&lang=js"

import "./color.vue?vue&type=style&index=0&id=72d34130&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72d34130"]])

export default __exports__